import {useState} from "react";

export const useTitleBrand = (baseCommunity) => {

    if (baseCommunity === "TheDonald") return "The Donald";
    return "Scored";

};


export const useTitle = (page, baseCommunity) => {

    const [brand, setBrand] = useState("Scored");

    if (baseCommunity === "TheDonald") setBrand("The Donald");

    switch (page) {
        case "Settings":
            return `Settings - ${brand}`;
        default:
            return brand;
    }

};
